import {
  LOGIN_DETAILS,
  FETCH_OTP,
  REGISTER_CHECK,
  RESEND_OTP,
  LOGIN_VERIFY_STEP,
  REGISTER_VERIFY_STEP,
  CLEAR_LOGIN_DATA,
  GLOBAL_DATA,
  LOGIN_ATTEMPTS,
} from 'App/store/constants';

const initialState = {
  loginDetails: null,
  registerDetails: null,
  loginVerifyStep: null,
  registerVerifyStep: null,
  attempts: null,
  globalData: null,
  errors: null,
  loading: false,
  data: null,
  // ISO-8601 expiry timestamp from server. Null when no OTP in flight.
  otpExpiresAt: null as string | null,
};

const reducer = (state = initialState, action: any) => {
  switch (action.type) {
    case GLOBAL_DATA:
      return { ...state, globalData: action.payload };

    case LOGIN_DETAILS:
      return { ...state, loginDetails: action.payload };

    case LOGIN_VERIFY_STEP:
      return { ...state, loginVerifyStep: null };

    case REGISTER_VERIFY_STEP:
      return { ...state, registerVerifyStep: null };

    case FETCH_OTP.PENDING:
      return { ...state, errors: null, loginVerifyStep: null, loading: true };
    case FETCH_OTP.SUCCESS:
      return {
        ...state,
        loginVerifyStep: true,
        loading: false,
        // Store server-supplied expiry so LoginVerify can show a live countdown
        otpExpiresAt: action.payload?.otp_expires_at ?? null,
      };
    case FETCH_OTP.FAILURE:
      return { ...state, errors: action.payload, loading: false };

    case REGISTER_CHECK.PENDING:
      return { ...state, errors: null, loading: true };
    case REGISTER_CHECK.SUCCESS:
      const response = action.payload;
      return {
        ...state,
        // registerVerifyStep: true,
        registerDetails: response,
        loading: false,
      };

    case REGISTER_CHECK.FAILURE:
      return { ...state, errors: action.payload, loading: false };

    case LOGIN_ATTEMPTS.FAILURE:
      return { ...state, errors: action.payload, loading: false };

    case LOGIN_ATTEMPTS.PENDING:
      return { ...state, errors: null, registerVerifyStep: null, loading: true };
    case LOGIN_ATTEMPTS.SUCCESS:
      return {
        ...state,
        attempts: action.payload,
        loading: false,
      };

    // Refresh expiry timestamp when OTP is resent
    case RESEND_OTP.SUCCESS:
      return {
        ...state,
        otpExpiresAt: action.payload?.otp_expires_at ?? null,
      };

    case CLEAR_LOGIN_DATA:
      return { ...state, loginDetails: null, registerDetails: null, loginVerifyStep: null, registerVerifyStep: null, otpExpiresAt: null };
    default:
      return state;
  }
};

export default reducer;
